<opac-button
  *ngIf="showReturnButton"
  [opac-go-back]="originPage"
  [forceNavigate]="true"
  class="back-button"
  type="text">
  <opac-icon slot="start" icon="navigate_back"></opac-icon>
  {{ 'general.back' | translate }}
</opac-button>

<div class="page-title">
  <h1 tabindex="0">{{ sectionTitle }}</h1>
</div>

<div class="loading-animation" *ngIf="searching">
  <div class="animation-row">
    <div class="double-bounce">
      <div class="child double-bounce1"></div>
      <div class="child double-bounce2"></div>
    </div>
  </div>
</div>

<opac-no-results *ngIf="!records && !searching" [label]="'results.noResults' | translate">
  <opac-no-results-results slot="custom-svg"></opac-no-results-results>

  <ng-container *ngIf="showExternalResults then externalResults"></ng-container>
  <ng-container *ngIf="showPurchaseSuggestions then purchaseSuggestions"></ng-container>
</opac-no-results>

<div [class.hide]="!records || (records && searching)">
  <div class="results__toolbar">
    <div class="left-side">
      <span
        class="results__toolbar__count"
        [tabIndex]="0"
        [attr.aria-label]="length + ' ' + ('general.items' | translate)"
        >{{ 'results.resultsLength' | translate:{resultsLength: length} }}</span
      >
    </div>

    <div class="right-side">
      <button
        mat-flat-button
        [opacTooltip]="'tooltip.saveSearch' | translate"
        class="results__toolbar__save only-icon"
        *ngIf="authService.isAuthenticated()"
        (keydown.enter)="saveSearch()"
        (keydown.space)="saveSearch()"
        (click)="saveSearch()"
        [attr.aria-label]="'tooltip.saveSearch' | translate">
        <span class="odilo-icon">save</span>
      </button>

      <button
        mat-flat-button
        *ngIf="showViewToggleButton"
        [opacTooltip]="'tooltip.view' | translate"
        class="results__toolbar__view only-icon"
        (keydown.enter)="toggleViewMode()"
        (keydown.space)="toggleViewMode()"
        (click)="toggleViewMode()"
        [attr.aria-label]="'tooltip.view' | translate">
        <span
          class="odilo-icon"
          *ngIf="selectedViewMode === 'LIST'"
          [attr.aria-label]="'general.viewMode.list' | translate"
          >view_1</span
        >
        <span
          class="odilo-icon"
          *ngIf="selectedViewMode === 'GRID'"
          [attr.aria-label]="'general.viewMode.grid' | translate"
          >view_2</span
        >
      </button>

      <div class="results__toolbar__sort" *ngIf="showFilters">
        <button
          mat-flat-button
          [matMenuTriggerFor]="sortMenu"
          [attr.aria-label]="('sort.options' | translate) + ' ' + (searchModel.order?.accessibilityKey | translate)">
          {{searchModel.order?.key | translate}}
          <span class="odilo-icon" aria-hidden="true">navigate_downward</span>
        </button>

        <mat-menu #sortMenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let elem of searchModel.getSortOptions()"
            (click)="sortBy(elem)"
            [attr.aria-label]="elem.accessibilityKey | translate">
            {{elem.key | translate}}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="results__toolbar__formats">
    <app-format-filter
      [filter]="formatFilter"
      [lists]="listFilter"
      (filterSelected)="onFilterSelected($event)"></app-format-filter>
  </div>

  <div class="app-results">
    <div #accessibilityAutofocus tabindex="0" class="accessibility-focus-element"></div>
    <div class="results-grid" *ngIf="records" [class.list-view]="selectedViewMode ===  'LIST'">
      <app-results-item
        *ngFor="let record of records; let i = index"
        class="results-grid__wrapper"
        [record]="record"
        [rating]="getRatingByRecord(record)"
        [viewMode]="selectedViewMode"
        (navigateResultsSection)="goToRecord(record, i)"></app-results-item>
    </div>

    <div>
      <ng-container *ngIf="showExternalResults then externalResults"></ng-container>
      <ng-container *ngIf="showPurchaseSuggestions then purchaseSuggestions"></ng-container>

      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"></mat-paginator>
    </div>
  </div>
</div>

<ng-template #externalResults>
  <div class="external-results">
    <p class="external-results__subtitle" tabindex="0">{{ 'results.externalSearches.prompt' | translate }}</p>

    <div class="external-results__buttons">
      <button *ngIf="showYoutubeButton" mat-flat-button class="btn-icon-text" (click)="youtubeResults()">
        <span class="odilo-icon">youtube</span>
        <span>Youtube</span>
      </button>
    </div>
    <p class="external-results__text">{{ 'results.externalSearches.text' | translate }}</p>
  </div>
</ng-template>

<ng-template #purchaseSuggestions>
  <div class="empty-space">
    <div class="suggestion-container above-pagination">
      <p class="suggestion-container__subtitle" tabindex="0">
        {{'results.suggestions.prompt' | translateByCustomerType:customerType.dbValue}}
      </p>

      <div class="suggestion-container__actions">
        <button mat-flat-button class="accent" (click)="suggestPurchase()">{{'general.yes' | translate}}</button>
        <button mat-flat-button class="accent transparent" (click)="showPurchaseSuggestions = false">
          {{'general.no' | translate}}
        </button>
      </div>

      <p class="suggestion-container__text">
        {{'results.suggestions.text' | translateByCustomerType:customerType.dbValue}}
      </p>
    </div>
  </div>
</ng-template>
